import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class MagazineRequest extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/magazine-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetMagazineRequests';

    static model_name = 'MagazineRequest';

    static fields() {
		return {
			id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
